import {
    cibCcAmex,
    cibCcApplePay,
    cibCcMastercard,
    cibCcPaypal,
    cibCcStripe,
    cibCcVisa,
    cibFacebook,
    cibGoogle,
    cibLinkedin,
    cibSap,
    cibSkype,
    cibTwitter,
    cifBr,
    cifEs,
    cifFr,
    cifIn,
    cifPl,
    cifUs,
    cilAccountLogout,
    cilActionUndo,
    cilAlignCenter,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilApps,
    cilArrowBottom,
    cilArrowLeft,
    cilArrowRight,
    cilArrowTop,
    cilBan,
    cilBasket,
    cilBell,
    cilBold,
    cilBookmark,
    cilCalculator,
    cilCalendar,
    cilCenterFocus,
    cilChart,
    cilChartPie,
    cilCheck,
    cilCheckAlt,
    cilCheckCircle,
    cilChevronBottom,
    cilChevronCircleDownAlt,
    cilChevronCircleUpAlt,
    cilChevronDoubleRight,
    cilChevronLeft,
    cilChevronRight,
    cilChevronTop,
    cilCircle,
    cilClock,
    cilCloudDownload,
    cilCloudUpload,
    cilCode,
    cilCommentSquare,
    cilContrast,
    cilCreditCard,
    cilCursor,
    cilDescription,
    cilDollar,
    cilDrop,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilExclamationCircle,
    cilExitToApp,
    cilExternalLink,
    cilFactory,
    cilFilter,
    cilFilterX,
    cilFile,
    cilGlobeAlt,
    cilGraph,
    cilGrid,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilInfo,
    cilInfoCircle,
    cilItalic,
    cilJustifyCenter,
    cilLanguage,
    cilLayers,
    cilList,
    cilListNumbered,
    cilLocationPin,
    cilLockLocked,
    cilLoopCircular,
    cilLowVision,
    cilMagnifyingGlass,
    cilMap,
    cilMediaPlay,
    cilMediaRecord,
    cilMenu,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperPlane,
    cilPaperclip,
    cilPen,
    cilPencil,
    cilPeople,
    cilPrint,
    cilPuzzle,
    cilReload,
    cilReportSlash,
    cilSave,
    cilSearch,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilStorage,
    cilStream,
    cilSun,
    cilTag,
    cilTags,
    cilTask,
    cilTrash,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilUserPlus,
    cilUserUnfollow,
    cilWarning,
    cilXCircle
} from '@coreui/icons-pro';

import { logo } from './logo';
import { signet } from './signet';

export const iconSubset = {
    cibCcAmex,
    cibCcApplePay,
    cibCcMastercard,
    cibCcPaypal,
    cibCcStripe,
    cibCcVisa,
    cibFacebook,
    cibGoogle,
    cibLinkedin,
    cibSap,
    cibSkype,
    cibTwitter,
    cifBr,
    cifEs,
    cifFr,
    cifIn,
    cifPl,
    cifUs,
    cilAccountLogout,
    cilActionUndo,
    cilAlignCenter,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilApps,
    cilArrowBottom,
    cilArrowLeft,
    cilArrowRight,
    cilArrowTop,
    cilBan,
    cilBasket,
    cilBell,
    cilBold,
    cilBookmark,
    cilCalculator,
    cilCalendar,
    cilCenterFocus,
    cilChart,
    cilChartPie,
    cilCheck,
    cilCheckAlt,
    cilCheckCircle,
    cilChevronBottom,
    cilChevronCircleDownAlt,
    cilChevronCircleUpAlt,
    cilChevronDoubleRight,
    cilChevronLeft,
    cilChevronRight,
    cilChevronTop,
    cilCircle,
    cilClock,
    cilCloudDownload,
    cilCloudUpload,
    cilCode,
    cilCommentSquare,
    cilContrast,
    cilCreditCard,
    cilCursor,
    cilDescription,
    cilDollar,
    cilDrop,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilExclamationCircle,
    cilExitToApp,
    cilExternalLink,
    cilFactory,
    cilFilter,
    cilFile,
    cilGlobeAlt,
    cilGraph,
    cilGrid,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilInfo,
    cilInfoCircle,
    cilItalic,
    cilJustifyCenter,
    cilLanguage,
    cilLayers,
    cilList,
    cilListNumbered,
    cilLocationPin,
    cilLockLocked,
    cilLoopCircular,
    cilLowVision,
    cilMagnifyingGlass,
    cilMap,
    cilMediaPlay,
    cilMediaRecord,
    cilMenu,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperPlane,
    cilPaperclip,
    cilPen,
    cilPencil,
    cilPeople,
    cilPrint,
    cilPuzzle,
    cilReload,
    cilReportSlash,
    cilSave,
    cilSearch,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilStorage,
    cilStream,
    cilSun,
    cilTag,
    cilTags,
    cilTask,
    cilTrash,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilUserPlus,
    cilUserUnfollow,
    cilWarning,
    cilXCircle,
    cilFilterX,
    logo,
    signet
};
